import {
  Directive,
  Input,
  OnInit
} from '@angular/core';
import { LMStyleDirectiveBase } from './lm-style-directive.base';

@Directive({
  selector: '[lm-text-style]', // tslint:disable-line
})
export class LMTextStyleDirective extends LMStyleDirectiveBase implements OnInit{
  @Input() set textStyle(textStyle: LMTextStyle) {
    this.style = textStyle;
  }

  ngOnInit() {
    this.setStyles();
  }
}
